import { render, staticRenderFns } from "./MyAssets.vue?vue&type=template&id=a9026108&scoped=true"
import script from "./MyAssets.vue?vue&type=script&lang=js"
export * from "./MyAssets.vue?vue&type=script&lang=js"
import style0 from "./MyAssets.vue?vue&type=style&index=0&id=a9026108&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9026108",
  null
  
)

export default component.exports